import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { VendorDetailsFragment } from "~/gql/queries/vendor.generated";

export type VendorsRefreshMode = "purge" | "rows";

export interface VendorsRefresh {
	mode: VendorsRefreshMode;
	revision: number;
}

interface VendorState {
	selectedVendor?: VendorDetailsFragment;
	vendorsRefresh: VendorsRefresh;
}

const initialState: VendorState = {
	vendorsRefresh: { mode: "purge", revision: 0 }
};

export const vendorSlice = createSlice({
	initialState,
	name: "vendor",
	reducers: {
		clearSelectedVendor: (state) => {
			state.selectedVendor = undefined;
		},
		setSelectedVendor: (state, action: PayloadAction<VendorDetailsFragment | null>) => {
			if (action.payload === null) {
				state.selectedVendor = undefined;
				return;
			}
			state.selectedVendor = { ...action.payload };
		},
		setVendorsRefresh: (state, action: PayloadAction<VendorsRefreshMode>) => {
			state.vendorsRefresh = { mode: action.payload, revision: state.vendorsRefresh.revision + 1 };
		},
		updateSelectedVendor: (state, action: PayloadAction<Partial<VendorDetailsFragment>>) => {
			if (!action.payload) {
				state.selectedVendor = undefined;
				return;
			}
			if (!state.selectedVendor) return;
			state.selectedVendor = { ...state.selectedVendor, ...action.payload };
		}
	}
});

export const { clearSelectedVendor, setSelectedVendor, setVendorsRefresh, updateSelectedVendor } = vendorSlice.actions;
export default vendorSlice.reducer;
